import { set } from "lodash";

const selectors = {
  showNoAdsToastResult: (state) => state.google.showNoAdsToastResult,
  getUserInfoResult: (state) => state.google.getUserInfoResult,
  setSyncedOfflineConversionsResult: (state) => state.google.setSyncedOfflineConversionsResult,
  getBusinessInfoResult: (state) => state.google.getBusinessInfoResult,
  getAccountDataResult: (state) => state.google.getAccountDataResult,
  getAccountHierarchyResult: (state) => state.google.getAccountHierarchyResult,
  getGoogleUserInfoResult: (state) => state.google.getGoogleUserInfoResult,
  autoLinkAccountResult: (state) => state.google.autoLinkAccountResult,
  setBusinessAdwordsIdResult: (state) => state.google.setBusinessAdwordsIdResult,
  setBusinessAdwordsNameResult: (state) => state.google.setBusinessAdwordsNameResult,
  setBusinessAdwordsCanAccessResult: (state) => state.google.setBusinessAdwordsCanAccessResult,
  getAdwordsConversionsDataResult: (state) => state.google.getAdwordsConversionsDataResult,
  getAdwordsConversionsLastsendResult: (state) => state.google.getAdwordsConversionsLastsendResult,
  createOfflineConversionResult: (state) => state.google.createOfflineConversionResult,
  getLinkAccountStatusResult: (state) => state.google.getLinkAccountStatusResult,
  getBusinessPipelinesResult: (state) => state.google.getBusinessPipelinesResult,
  getBusinessStepsResult: (state) => state.google.getBusinessStepsResult,
  getAdwordsPipelineConversionsDataResult: (state) => state.google.getAdwordsPipelineConversionsDataResult,
  createAdwordsPipelineConversionsDataResult: (state) => state.google.createAdwordsPipelineConversionsDataResult,
  getOfflineConversionAddonResult: (state) => state.google.getOfflineConversionAddonResult,
  updateOfflineConversionAddonResult: (state) => state.google.updateOfflineConversionAddonResult,
  changeSettingPageResult: (state) => state.google.changeSettingPageResult,
  setRwidgetConversionDefaultValueResult: (stage) => stage.google.setRwidgetConversionDefaultValueResult,
  getGoogleSheetsListResult: (state) => state.google.getGoogleSheetsListResult,
  getGoogleExchangeTokenResult: (state) => state.google.getGoogleExchangeTokenResult,
  setGoogleAccountResult: (state) => state.google.setGoogleAccountResult,
  getGoogleAccountResult: (state) => state.google.getGoogleAccountResult,
  setGoogleSheetsSettingResult: (state) => state.google.setGoogleSheetsSettingResult,
  getGoogleAdsLeadFormResult: (state) => state.google.getGoogleAdsLeadFormResult,
  changeGoogleAdsFormSelectTypeResult: (state) => state.google.changeGoogleAdsFormSelectTypeResult,
  setCheckedGoogleAdsFormItemsResult: (state) => state.google.setCheckedGoogleAdsFormItemsResult,
  setGoogleLeadGoogleConnectedResult: (state) => state.google.setGoogleLeadGoogleConnectedResult,
  setGoogleLeadGoogleDisconnectedResult: (state) => state.google.setGoogleLeadGoogleDisconnectedResult,
  changeGoogleLeadSheetsUrlInputResult: (state) => state.google.changeGoogleLeadSheetsUrlInputResult,
  setGoogleAdsLeadFormSettingResult: (state) => state.google.setGoogleAdsLeadFormSettingResult,
  setGoogleSheetsGGLeadsSettingResult: (state) => state.google.setGoogleSheetsGGLeadsSettingResult,
  getAllGoogleLeadFormSettingsResult: (state) => state.google.getAllGoogleLeadFormSettingsResult,
  switchGoogleLeadFormStatusResult: (state) => state.google.switchGoogleLeadFormStatusResult,
  archiveGoogleLeadFormSettingResult: (state) => state.google.archiveGoogleLeadFormSettingResult,
  getGoogleAdsSettingResult: (state) => state.google.getGoogleAdsSettingResult,
  getGoogleSheetsSettingResult: (state) => state.google.getGoogleSheetsSettingResult,
  getGoogleLeadCRMSettingResult: (state) => state.google.getGoogleLeadCRMSettingResult,
  getGoogleLeadFormSettingResult: (state) => state.google.getGoogleLeadFormSettingResult,
  setValidateGoogleLeadFormResult: (state) => state.google.setValidateGoogleLeadFormResult,
  setValidateGoogleSheetsUrlResult: (state) => state.google.setValidateGoogleSheetsUrlResult,
  setValidateGGLeadsGoogleSheetsUrlResult: (state) => state.google.setValidateGGLeadsGoogleSheetsUrlResult,
  setDuplicateGoogleFormResult: (state) => state.google.setDuplicateGoogleFormResult,
  getLeadStepsResult: (state) => state.google.getLeadStepsResult,
  getGoogleSheetsOfflineConversionsValueResult: (state) => state.google.getGoogleSheetsOfflineConversionsValueResult,
  setGoogleSheetsOfflineConversionsValueResult: (state) => state.google.setGoogleSheetsOfflineConversionsValueResult,
  getGoogleSheetsOfflineConversionsLastSentResult: (state) =>
    state.google.getGoogleSheetsOfflineConversionsLastSentResult,
  updateGGLeadFormSettingErrorStatusResult: (state) => state.google.updateGGLeadFormSettingErrorStatusResult,
  setFileInfoErrorResult: (state) => state.google.setFileInfoErrorResult,
  setGoogleLoadingResult: (state) => state.google.setGoogleLoadingResult,
  setGoogleSheetsLoadingResult: (state) => state.google.setGoogleSheetsLoadingResult,
  setGoogleSheetsErrorResult: (state) => state.google.setGoogleSheetsErrorResult,
  setGoogleAdsLoadingResult: (state) => state.google.setGoogleAdsLoadingResult,
  setGGConnectionLoadingResult: (state) => state.google.setGGConnectionLoadingResult,
};

export default selectors;
